import React, { Component } from 'react'
import axios from 'axios'
import { API_URL } from '../constants'
import {
  map,
  pick,
  orderBy,
  uniqBy,
  isEmpty,
  get,
  toUpper,
  capitalize,
  indexOf,
  flatMap,
  flatten,
  size,
  has,
  lowerCase,
  intersection
} from 'lodash'
import qs from 'qs'
import {
  PageWrapper,
  Header,
  Card,
  FlexWrapper,
  Button,
  ProductViewWrapper,
  ProductView,
  PageLoader
} from '../components'
import Cookies from 'js-cookie'
import { gsCalculator, priceRangeCalculator, showHeaderFromUrl, isAdmin, filterHiddenData } from '../utlis/functions'

class ViewMore extends Component {
  state = { loader: false, data: [], favroitesData: [] }
  async componentDidMount() {
    this.setState({ loader: true })
    if (this.props.location.pathname === '/favorites') {
      await this.fetchFavoritesProducts()
    } else if (this.props.location.pathname === '/recently-searched') {
      await this.fetchRecentlySearch()
    }
    await this.fetchWarningConflicts()
    await this.getFavouriteData()
    await this.setState({ loader: false })
  }

  fetchWarningConflicts = async () => {
    const warningQuery = {
      filter: { include: ['diets', 'allergies'] }
    }
    try {
      const { data } = await axios.get(`${API_URL}/users/${Cookies.get('user_id')}?${qs.stringify(warningQuery)}`)
      this.setState({ userData: data })
    } catch (error) {
      this.setState({ loader: false })
      console.log('ERROR', error)
    }
  }

  fetchFavoritesProducts = async () => {
    const favQuery = {
      filter: {
        include: ['greenScores', 'productCost', 'users'],
        limit: 10
      }
    }
    try {
      const { data } = await axios.get(
        `${API_URL}/users/${Cookies.get('user_id')}/productTables?${qs.stringify(favQuery)}`
      )
      this.setState({ data })
    } catch (error) {
      this.setState({ loader: false })
      console.log('ERROR', error)
    }
  }

  fetchRecentlySearch = async () => {
    const recentSearchQuery = {
      filter: {
        where: {
          productCode: {
            neq: null
          },
          userId: Cookies.get('user_id')
        },
        order: ['date DESC'],
        limit: 40
      }
    }

    const productSearch = term => ({
      filter: {
        limit: 30,
        include: ['greenScores', 'productCost', 'users'],
        where: {
          productCode: term
        },
        order: ['totalGs DESC']
      }
    })

    try {
      const { data: recentlySearchedTerms } = await axios.get(
        `${API_URL}/UserRecentSearchedProducts?${qs.stringify(recentSearchQuery)}`
      )

      const products = await Promise.all(
        recentlySearchedTerms.map(async item => {
          const { data } = await axios.get(`${API_URL}/ProductTables?${qs.stringify(productSearch(item.productCode))}`)
          return data
        })
      )

      this.setState({
        data: uniqBy(flatten(products), 'productCode')
      })
    } catch (error) {
      console.log(error)
      this.setState({ loader: false })
    }
  }

  getFavouriteData = async () => {
    try {
      const { data } = await axios.get(
        `${API_URL}/users/${Cookies.get('user_id')}/productTables?filter=%7B%22fields%22%3A%22productCode%22%7D`
      )
      this.setState({ favouriteData: data })
    } catch (error) {
      console.log('ERROR', error)
    }
  }
  changeFavouriteData = async id => {
    const query = {
      filter: {
        where: { userId: Cookies.get('user_id'), productCode: id }
      }
    }
    const { data } = await axios.get(`${API_URL}/UserProducts?${qs.stringify(query)}`)
    if (data.length === 0) {
      await axios.post(`${API_URL}/UserProducts`, {
        productCode: id,
        userId: Cookies.get('user_id')
      })
      await this.getFavouriteData()
    } else {
      await axios.delete(`${API_URL}/UserProducts/${data[0].id}`)
      await this.getFavouriteData()
    }
  }
  render() {
    const { location } = this.props
    const { favouriteData, data, loader, userData } = this.state
    const favouriteDataz = flatMap(favouriteData, 'productCode')
    const userDiets = get(userData, 'diets', []).map(item => lowerCase(item.diet))
    const userAllergies = get(userData, 'allergies', []).map(item => lowerCase(item.allergy))
    return (
      <React.Fragment>
        <Header
          title={showHeaderFromUrl(get(location, 'pathname', ''))}
          icon="arrowBack"
          onClickBack={() => this.props.history.goBack()}
          color="#fff"
        />
        <PageWrapper viewPadding="22.4% 4.3% 6.4%" height="auto" modifyPadding="84px 16px 24px">
          {loader ? (
            <PageLoader />
          ) : isEmpty(filterHiddenData(data)) ? (
            <Card boxShadow="0 3px 6px 0 rgba(0, 0, 0, 0.16)" borderRadius="5px" bgColor="#fff">
              <FlexWrapper alignItems="center">
                <h3>No Results available</h3>
                <Button
                  type="submit"
                  label="View Products"
                  volume="filled"
                  margin="14px 10px 0"
                  size="small"
                  onClick={() => this.props.history.push('/products')}
                />
              </FlexWrapper>
            </Card>
          ) : (
            <ProductViewWrapper direction="row" flexWrap="wrap" justifyContent="space-between">
              {filterHiddenData(data).map(item => {
                const priceRange = get(item, 'productCost', []).map(range =>
                  range.productPriceSale ? range.productPriceSale : range.productPriceOriginal
                )
                const allergyConflicts = get(item, 'allergyConflicts', '')
                  .replace(/(\r\n\t|\n|\r\t|\r)/gm, '')
                  .toLowerCase()
                  .split(',')
                  .map(item => item.trim())
                const dietConflicts = get(item, 'dietConflicts', '')
                  .replace(/(\r\n\t|\n|\r\t|\r)/gm, '')
                  .toLowerCase()
                  .split(',')
                  .map(item => item.trim())
                return (
                  <ProductView
                    conflict={
                      !isEmpty(intersection(userAllergies, allergyConflicts)) ||
                      !isEmpty(intersection(userDiets, dietConflicts))
                    }
                    cardMargin="0 0 10px 0"
                    cardWidth="166px"
                    cardHeight="236px"
                    favValue={get(item, 'users', '') ? get(item, 'users.length', '') : 0}
                    key={item.productCode}
                    imageUrl={get(item, 'productImage', '')}
                    quantity={
                      size(get(item, 'productCost[0].productQuantity', '')) < 15
                        ? toUpper(get(item, 'productCost[0].productQuantity', ''))
                        : ''
                    }
                    productName={capitalize(get(item, 'productName', ''))}
                    priceRange={priceRangeCalculator(priceRange)}
                    progressValue={gsCalculator(get(item, 'greenScores', ''))}
                    isFavorite
                    isHidden={isAdmin() && item.isHidden ? true : false}
                    favoriteActive={indexOf(favouriteDataz, get(item, 'productCode', '')) === -1 ? false : true}
                    onFavorite={() => this.changeFavouriteData(get(item, 'productCode', ''))}
                    onClick={() =>
                      this.props.history.push({
                        pathname: `/products/${get(item, 'productCode', '')}/green-score`
                      })
                    }
                  />
                )
              })}
            </ProductViewWrapper>
          )}
        </PageWrapper>
      </React.Fragment>
    )
  }
}

export default ViewMore



// WEBPACK FOOTER //
// ./src/pages/ViewMore.js